import React from 'react';
import Cspage from 'components/csboard/CS_Top'

const CSBoard = (props) => {
    
    return (
        <div>
            <Cspage  {...props} />
        </div>
    );
};

export default CSBoard;